/**
 * @generated SignedSource<<b40e6173dadf7923ee425b844dadc8a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPageOverlay_sheet$data = {
  readonly id: string;
  readonly width: number;
  readonly height: number;
  readonly tie_finder_steps: ReadonlyArray<{
    readonly id: string;
    readonly data: {
      readonly ties?: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayTie_Tie">;
      }>;
    } | null;
  }>;
  readonly bar_line_processor_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
    readonly data: {
      readonly masks?: ReadonlyArray<{
        readonly key: string;
        readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageBarLineMask_mask">;
      }>;
    } | null;
  }>;
  readonly note_combine_steps: ReadonlyArray<{
    readonly id: string;
    readonly status: MusicParseStatus;
    readonly data: {
      readonly notes?: ReadonlyArray<{
        readonly note_id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlayNote_Note">;
      }>;
      readonly sharp_flat_naturals?: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural">;
      }>;
    } | null;
  }>;
  readonly " $fragmentType": "NoteFinderPageOverlay_sheet";
};
export type NoteFinderPageOverlay_sheet$key = {
  readonly " $data"?: NoteFinderPageOverlay_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlay_sheet">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPageOverlay_sheet",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "width",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "height",
      "storageKey": null
    },
    {
      "alias": "tie_finder_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "MUSIC_TIE_FINDER"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataTieFinderTie",
                  "kind": "LinkedField",
                  "name": "ties",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NoteFinderPageOverlayTie_Tie"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataTieFinder",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"MUSIC_TIE_FINDER\")"
    },
    {
      "alias": "bar_line_processor_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "BAR_LINE_PROCESSOR"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataBarLineProcessorMask",
                  "kind": "LinkedField",
                  "name": "masks",
                  "plural": true,
                  "selections": [
                    {
                      "alias": "key",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "mask_storage_name",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NoteFinderPageBarLineMask_mask"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataBarLineProcessor",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"BAR_LINE_PROCESSOR\")"
    },
    {
      "alias": "note_combine_steps",
      "args": [
        {
          "kind": "Literal",
          "name": "step_type",
          "value": "NOTE_DATA_SOURCE_COMBINE"
        }
      ],
      "concreteType": "MusicParseStep",
      "kind": "LinkedField",
      "name": "steps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataNoteDataSourceCombineNote",
                  "kind": "LinkedField",
                  "name": "notes",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "note_id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NoteFinderPageOverlayNote_Note"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MusicParseStepDataNoteDataSourceCombineSharpFlatNatural",
                  "kind": "LinkedField",
                  "name": "sharp_flat_naturals",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "MusicParseStepDataNoteDataSourceCombine",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "steps(step_type:\"NOTE_DATA_SOURCE_COMBINE\")"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};
})();

(node as any).hash = "fd906aef1a1f835278b365bbe2d6e88f";

export default node;
